import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";

export const TabsSettings = [
  { label: "Layout", value: "layout", i18n: "layout" },
  { label: "Content", value: "content", i18n: "content" },
];

export const ContentLoadSettings = [
  { label: "Dynamic", value: "dynamic", i18n: "dynamic" },
  { label: "Manual", value: "manually", i18n: "manual" },
];

export const SpaceType = {
  GLOBAL: "global",
  PERSONAL: "personal",
};

export const SpaceStatus = {
  ACTIVE: "current",
  ARCHIVED: "archived",
};

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 20 },
];

export const SpacesVariants = {
  CARD: "card",
  LIST: "list",
};

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const SpaceElements = {
  DESCRIPTION: "description",
  AUTHOR: "author",
};

export const DefaultActiveElements = [
  SpaceElements.AUTHOR,
  SpaceElements.DESCRIPTION,
];
